import {
  GET_CLIENT_DETAIL_DATA,
  GET_CLIENT_DETAILS_PAGINATOR,
  GET_CLIENT_LIST_DATA,
  SET_CLIENT_CARE_ACTIVITY_SELECTED_ITEMS,
  SET_CLIENT_DETAIL_DATA,
  SET_CLIENT_DETAILS_PAGINATOR,
  SET_CLIENT_LIST_DATA,
  SET_NOTE_CLIENT_DATA,
} from '@stores/client/constans.js';

const getClientslistDataAction = (payload) => ({
  type: GET_CLIENT_LIST_DATA,
  payload,
});
const setClientslistDataAction = (payload) => ({
  type: SET_CLIENT_LIST_DATA,
  payload,
});
const setNoteClientDataAction = (payload, callback) => ({
  type: SET_NOTE_CLIENT_DATA,
  payload,
  callback,
});
const getClientDetailDataAction = (payload) => ({
  type: GET_CLIENT_DETAIL_DATA,
  payload,
});
const setClientDetailDataAction = (payload) => ({
  type: SET_CLIENT_DETAIL_DATA,
  payload,
});
const getPolicyListForClientAction = (payload) => ({
  type: GET_CLIENT_DETAILS_PAGINATOR,
  payload,
});
const setPolicyListForClientAction = (payload) => ({
  type: SET_CLIENT_DETAILS_PAGINATOR,
  payload,
});

const setClientCareActivitySelectedItems = (payload) => ({
  type: SET_CLIENT_CARE_ACTIVITY_SELECTED_ITEMS,
  payload,
});

export {
  getClientslistDataAction,
  setClientslistDataAction,
  setNoteClientDataAction,
  getClientDetailDataAction,
  setClientDetailDataAction,
  getPolicyListForClientAction,
  setPolicyListForClientAction,
  setClientCareActivitySelectedItems,
};
